import { computed, inject, Injectable, signal } from '@angular/core';
import { UserApiService } from '@entities/user/data-access/user.api-service';
import { UserModel } from '@entities/user/models/user.model';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private readonly _userApiService = inject(UserApiService);

  private readonly _user = signal<UserModel | null>(null);

  public readonly user = this._user.asReadonly();
  public readonly userId = computed(() => this._user()?.id ?? null);

  public load(): Observable<UserModel> {
    return this._loadCurrentUser();
  }

  public refresh(): Observable<UserModel> {
    return this._loadCurrentUser();
  }

  public clear(): void {
    this._user.set(null);
  }

  private _loadCurrentUser(): Observable<UserModel> {
    return this._userApiService.getCurrentUser().pipe(tap(user => this._user.set(user)));
  }
}
